'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { SegmentedControl as NativeSegmentedControl } from '@mantine/core';

// Types
import { SegmentedControlProps } from './types';

// Styles
import * as classes from './styles/index.css';
import * as segmentedControlStylesAPI from './styles/segmentedControlStylesAPI.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function SegmentedControl(props: SegmentedControlProps) {
  /* ********************************** HOOKS ********************************* */

  // Styles

  /* ******************************** RENDERING ******************************* */
  return (
    <NativeSegmentedControl
      className={classes.segmentedControl}
      classNames={{ ...segmentedControlStylesAPI }}
      radius="sm"
      {...props}
    />
  );
}

export default SegmentedControl;
